import Quill from 'quill';

const BlotBlockEmbed = Quill.import('blots/block/embed') as any;

class PageBreakBlot extends BlotBlockEmbed {
  static blotName = 'pagebreak';
  static tagName = 'hr';

  static create(value:any) {
    const node = super.create(value);
    node.style = 'page-break-after: always;';
    return node;
  }
}

Quill.register(PageBreakBlot, true);